import TreeListColumnProps from './Columns'
import Vue from 'vue'

let KendoTreeListColumn = {
    name: 'kendo-treelist-column',
    render () {
        return Vue.prototype._e
    },
    mixins: [TreeListColumnProps]
}

export default KendoTreeListColumn


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeListColumn/index.js